<template>
<div>
    <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Calendar</v-tab>
        <v-tab>List</v-tab>
    </v-tabs>

    <div v-if="tab==0">
        <v-toolbar flat color="white">
            <v-btn @click="$refs.calendar.prev()" icon>
                <v-icon>
                    keyboard_arrow_left
                </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title @click="dateModal=true" style="cursor: pointer">{{formatMonth(date)}}

            </v-toolbar-title>
            <v-btn icon color="primary" small @click="addTask()">
                <v-icon color='white' small>add</v-icon>

            </v-btn>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" small icon style="margin-right: 0" @click="attachTemplateModal=true">
                        <v-icon color="white" small>add_link</v-icon>
                    </v-btn>
                </template>
                <span>Add task from template</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn @click="$refs.calendar.next()" icon>
                <v-icon>
                    keyboard_arrow_right
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-layout>
            <v-flex>
                <v-sheet height="500">
                    <v-calendar v-model="date" ref="calendar" :type="type" :value="date" @change="getEvents" @click:date="addTask($event.date)">
                        <template v-slot:day="{ date }" class="ma-0 pa-0">
                            <v-list class="ma-0 pa-0" v-if="dateIndex(date)>-1">
                                <draggable v-model="tasks[dateIndex(date)].tasks" :options='{group: "weektasks"}' @change="change" style="min-height: 60px">

                                    <v-list-tile v-for="task in tasks[dateIndex(date)].tasks" :key="task.id" class="ma-0 pa-0" hover :style="{'cursor': 'pointer', 'fontSize': '10px', 'border-bottom': '1px solid lightgrey', 'border-left': '5px solid ' + getStatusColor(task)}">

                                        <v-list-tile-content class="ma-0 pa-0" style="cursor: pointer" @click="viewTask(task)">
                                            <v-list-tile-sub-title style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;" class="text-wrap" v-html="task.name">
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action v-if="!task.loading && (task.dueTime || task.assignedTo)">
                                            <span style="font-size: 10px" v-if="task.dueTime">{{formatTime(task.dueTime)}}</span>
                                            <v-tooltip top v-if="task.assignedTo">
                                                <template v-slot:activator="{ on }">
                                                    <v-avatar v-on="on" size="23px" color="blue" class="title white--text" v-if="
                              task.assignedTo
                            ">
                                                        <small style="font-size: 10px">{{ task.assignedTo.name.charAt(0)
                              }}{{
                                task.assignedTo.surname.charAt(0)
                              }}</small>
                                                    </v-avatar>
                                                </template>
                                                <span>{{ task.assignedTo.name
                              }} {{
                                task.assignedTo.surname
                              }}</span>
                                            </v-tooltip>
                                        </v-list-tile-action>
                                        <v-list-tile-action v-else-if="task.loading">
                                            <v-progress-circular indeterminate color="grey" size="20"></v-progress-circular>
                                        </v-list-tile-action>

                                    </v-list-tile>
                                </draggable>
                            </v-list>
                        </template>
                    </v-calendar>

                </v-sheet>
            </v-flex>
        </v-layout>

    </div>

    <div v-else-if="tab==1">
        <v-toolbar dense flat color="white">
            <v-btn small outline style="border-radius: 5px; font-size: 12px" @click="addTask()">
                <v-icon small class="mr-1">add</v-icon>
                New Task
            </v-btn>
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small flat style="font-size: 12px">
                        <v-icon small class='mr-1'>filter_list</v-icon> Filter
                        <span v-if="filterType">: {{filterType.shortName}}</span>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-tile v-if="filterType" @click="filterType=null">
                        <v-list-tile-action>
                            <v-icon>clear</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 12px">Remove Filter</v-list-tile-title>
                        </v-list-tile-content>

                    </v-list-tile>
                    <v-list-tile v-for="(filter, index) in filterList" :key="index" @click="filterType=filter">
                        <v-list-tile-action>
                            <v-icon>{{filter.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 12px">{{ filter.name }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small flat style="font-size: 12px">
                        <v-icon small class="mr-1">task_alt</v-icon>
                        <span>{{taskFilter}}</span>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-tile v-for="(filter, index) in taskFilterList" :key="index" @click="taskFilter=filter">
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 12px">{{ filter }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>

        </v-toolbar>
        <v-layout>
            <v-flex :style="{width: displayListTask?'50%':'100%'}">
                <v-data-table :items="listTasks" :headers="taskHeaders" style="cursor: pointer" hide-actions disable-initial-sort>
                    <template v-slot:items="props">
                        <tr :style="{border: selectedTask && selectedTask.id == props.item.id?'1px solid black':'none'}">
                            <td class="text-xs-center" @click="selectTask(props.item)">
                                <span> {{props.item.id}}</span>
                            </td>
                            <td class="text-xs-left" @click="selectTask(props.item)" :style="{'border-left': '5px solid ' + getStatusColor(props.item)}">
                                <v-btn icon small style="font-size: 10px">
                                    <v-icon small color="grey">subdirectory_arrow_right</v-icon>
                                    {{props.item.subTaskCount}}
                                </v-btn>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on" :style="{color: props.item.status=='Complete'||props.item.status=='Canceled'?'grey':'black' }"> {{props.item.name}}</span>

                                    </template>
                                    <span>{{props.item.status}}</span>
                                </v-tooltip>

                            </td>
                            <td class="text-xs-left" @click="selectTask(props.item)">
                                <span v-if="props.item.assignedTo"> {{props.item.assignedTo.name}} {{props.item.assignedTo.surname}}</span>
                                <v-hover v-if="!props.item.assignedTo">
                                    <v-flex>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small class="dotted" style="color: grey" icon>
                                                    <v-icon color="grey" small>person</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Assign this task</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-hover>

                            </td>
                            <td class="text-xs-left" @click="selectTask(props.item)">
                                <span :style="{'font-size': '12px', cursor: 'pointer', 'font-weight': 'bold', color: props.item.status=='Complete'||props.item.status=='Canceled'?'lightgrey':isFuture(props.item.dueDate)?'black': 'red'}">
                                    {{formatSelectedDay(props.item)}}</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>

            </v-flex>
            <v-flex v-if="selectedTask&&displayListTask" style="overflow-y: auto; max-height: 80vh; width: 50%">
                <TaskModal :item="selectedTask" @close="displayListTask=false,taskModal=false, selectedTask={}" @taskCreated="taskModal=false,fetchTasks()" @showSubtask="selectTask" :key="modalKey" />
            </v-flex>
        </v-layout>

    </div>

    <v-dialog ref="dialog" v-model="dateModal" lazy full-width width="750px">
        <v-date-picker style="height: 350px" landscape full-width scrollable v-model="date">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateModal=false">OK</v-btn>
        </v-date-picker>

    </v-dialog>

    <v-dialog v-model="taskModal" width="1024px" persistent>
        <v-card>
            <TaskModal :item="item" @close="taskModal=false, item={}" @taskCreated="taskModal=false,fetchTasks()" @showSubtask="viewTask(data)" :key="modalKey" />
        </v-card>
    </v-dialog>

    <v-dialog v-model="attachTemplateModal" width="800px" persistent>
        <v-card>
            <v-toolbar flat color='white'>
                <v-toolbar-title>Select a template</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="attachTemplateModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table :items="templates" :headers="templateHeaders" style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center" @click="createFromtemplate(props.item)">{{ props.item.name }}</td>
                        <td class="text-xs-center" @click="createFromtemplate(props.item)">{{ props.item.description }}</td>
                        <td class="text-xs-center" @click="createFromtemplate(props.item)">
                            <v-chip>{{props.item.taskTemplateForms.length}}</v-chip>
                        </td>
                        <td class="text-xs-center" @click="createFromtemplate(props.item)">
                            <v-chip>{{props.item.taskTemplateCollaborators.length}}</v-chip>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
import draggable from "vuedraggable";
import TaskModal from '../components/TaskModal.vue';

export default {
    components: {
        draggable,
        TaskModal
    },
    data: () => ({
        attachTemplateModal: false,
        date: new Date().toISOString().substr(0, 10),
        dateModal: false,
        displayListTask: false,
        forms: [],
        filterList: [{
                type: 'myTasks',
                icon: 'person',
                name: 'My Tasks',
                shortName: 'My Tasks'
            },
            {
                type: 'thisWeek',
                icon: 'event',
                name: 'Due this Week',
                shortName: 'This Week'
            },
            {
                type: 'nextWeek',
                icon: 'event',
                name: 'Due next Week',
                shortName: 'Next Week'
            },

        ],
        templateHeaders: [{
                text: "Title",
                align: "center",
                value: "name"
            },
            {
                text: "Description",
                align: "center",
                value: "description"

            }, {
                text: "Forms",
                align: "center",
                value: "taskTemplateForms.length"

            }, {
                text: "Collaborators",
                align: "center",
                value: "taskTemplateCollaborators.length"

            }
        ],
        filterType: null,
        item: {
            subtasks: []
        },
        modalKey: 0,
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1, 12).toISOString().substr(0, 10),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10),
        selectedTask: null,
        taskModal: false,
        tab: 0,
        tasks: [],
        taskHeaders: [{
                text: "#",
                align: "center",
                value: "id",
                width: '20px',
                sortable: false
            },
            {
                text: "Task",
                align: "left",
                value: "name",
                sortable: false
            },
            {
                text: "Assignee",
                align: "left",
                value: "assignedTo.name",
                width: '60px',
                sortable: false
            },
            {
                text: "Due Date",
                align: "left",
                value: "dueDate",
                width: '60px',
                sortable: false

            },
        ],
        typeOptions: [{
                text: 'Day',
                value: 'day'
            },
            {
                text: '4 Day',
                value: '4day'
            },
            {
                text: 'Week',
                value: 'week'
            },
            {
                text: 'Month',
                value: 'month'
            },
            {
                text: 'Custom Daily',
                value: 'custom-daily'
            },
            {
                text: 'Custom Weekly',
                value: 'custom-weekly'
            }
        ],
        taskFilter: 'All Tasks',
        taskFilterList: ['All Tasks', 'Completed Tasks', 'Incomplete Tasks'],
        templates: [],
        type: 'month',
    }),
    computed: {
        row_classes(item) {
            if (this.selectedTask && item.id == this.selectedTask.id) {
                return "blue";
            }
        },
        listTasks() {
            let result = [].concat.apply([], this.tasks.map(x => x.tasks));
            if (this.taskFilter == 'Completed Tasks' || this.taskFilter == 'Incomplete Tasks') {
                if (this.taskFilter == 'Incomplete Tasks') {
                    result = result.filter(x => x.status != 'Complete' && x.status != 'Canceled')
                } else if (this.taskFilter == 'Completed Tasks') {
                    result = result.filter(x => x.status == 'Complete')
                }
            }
            if (this.filterType) {
                if (this.filterType.type == 'myTasks') {
                    result = result.filter(x => x.assignedToId == this.$store.state.user.id)
                } else if (this.filterType.type == 'thisWeek') {
                    let week = this.getWeek(new Date())
                    console.log(week)

                    result = result.filter(x => x.dueDate && new Date(x.dueDate) >= week[0] && new Date(x.dueDate) <= week[1])
                } else if (this.filterType.type == 'nextWeek') {
                    let date = new Date()
                    date.setDate(date.getDate() + 7)
                    let week = this.getWeek(date)
                    console.log(week)
                    result = result.filter(x => x.dueDate && new Date(x.dueDate) >= week[0] && new Date(x.dueDate) <= week[1])
                }
            }
            let incomplete = result.filter(x => x.status != 'Complete' && x.status != 'Canceled')
            incomplete.sort((a, b) =>
                new Date(a.dueDate) > new Date(b.dueDate) ?
                1 :
                new Date(b.dueDate) > new Date(a.dueDate) ?
                -1 :
                0
            )
            let complete = result.filter(x => x.status == 'Complete' || x.status == 'Canceled')
            complete.sort((a, b) =>
                new Date(a.dueDate) > new Date(b.dueDate) ?
                1 :
                new Date(b.dueDate) > new Date(a.dueDate) ?
                -1 :
                0
            )
            result = [...incomplete, ...complete]
            return result
        }
    },
    watch: {},
    created() {
        this.getTaskTemplates()
        this.getForms()
    },
    mounted() {
        let val = new Date(this.startDate)
        var week = new Array();
        val.setDate((val.getDate() - val.getDay()));
        this.startDate = val.toISOString().substr(0, 10)

        let end = new Date(this.endDate)
        for (var i = 0; i < 7; i++) {
            week.push(
                new Date(end)
            );
            end.setDate(end.getDate() + 1);
        }
        this.endDate = week[week.length - 1].toISOString().substr(0, 10)
        this.fetchTasks()

    },
    methods: {
        addTask(date = new Date().toISOString().substr(0, 10)) {
            this.item = {
                status: 'Pending',
                dueDate: date,
                documents: [],
                subtasks: [],
                taskCollaborators: [],
                taskForms: [],
                taskChanges: [],
                locationType: 'location'
            }
            this.taskModal = true
        },
        async change(event) {
            let keys = Object.keys(event)
            if (keys.includes('added')) {
                let day = this.tasks.find(x => x.tasks.map(y => y.id).includes(event.added.element.id))
                day.tasks[event.added.newIndex].dueDate = day.date
                await this.updateTask({
                    id: event.added.element.id,
                    dueDate: day.date
                })
            }
        },
        createFromtemplate(template, date = new Date().toISOString().substr(0, 10)) {
            this.item = {
                status: 'Pending',
                name: template.name,
                description: template.description,
                assignedToId: template.assignedToId,
                userRoleId: template.userRoleId,
                dueDate: date,
                documents: [],
                subtasks: [],
                taskCollaborators: template.taskTemplateCollaborators.map(x => ({
                    contact: x.contact,
                    contactId: x.contactId
                })),
                taskForms: template.taskTemplateForms.map(x => ({
                    form: x.form,
                    formId: x.formId
                })),
                taskChanges: [],
                locationType: 'location'
            }
            console.log(template)
            console.log(this.item)

            this.attachTemplateModal = false
            this.taskModal = true
        },
        getEvents({
            start,
            end
        }) {
            let viewStart = this.$refs.calendar.getStartOfWeek(start);
            let viewEnd = this.$refs.calendar.getEndOfWeek(end);
            if (this.startDate != viewStart.date || this.endDate != viewEnd.date) {
                this.startDate = viewStart.date
                this.endDate = viewEnd.date
                this.fetchTasks()
            }
        },

        dateIndex(date) {
            let find = this.tasks.find(x => x.date == date)
            let index = -1
            if (find) {
                index = this.tasks.indexOf(find)
            }
            return index
        },
        fetchTasks() {
            Api().get('/tasks/' + this.startDate + '/' + this.endDate).then(res => {
                this.tasks = res.data
            })
        },
        async fetchTaskCollaborators(id) {
            let result = []
            await Api().get('/collaborators/' + id).then(res => {
                result = res.data
            })
            return result
        },
        async fetchSubtasks(id) {
            let result = []
            await Api().get('/subtasks/' + id).then(res => {
                result = res.data
            })
            return result
        },
        formatMonth(date) {
            if (date !== null) {
                return dateformat(date, "mmmm yyyy");
            } else {
                null;
            }
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        formatDay(date) {
            if (date !== null) {
                return dateformat(date, "ddd dd, mmm");
            } else {
                null;
            }
        },

        formatTime(time) {
            return time.split(':')[0] + ':' + time.split(':')[1]
        },
        formatSelectedDay(item) {
            let today = this.formatDate(new Date())
            let time = item.dueTime
            if (time) {
                time = time.split(':')[0] + ':' + time.split(':')[1]
            }
            if (today == item.dueDate) {
                let result = 'Today'
                if (time) {
                    result += ' ' + time
                }
                return result
            } else {
                return this.formatDay(item.dueDate)
            }
        },
        getWeek(day) {
            let val = new Date(day)
            var week = new Array();
            val.setDate((val.getDate() - val.getDay()));
            for (var i = 0; i < 7; i++) {
                week.push(
                    new Date(val)
                );
                val.setDate(val.getDate() + 1);
            }
            return [week[0], week[week.length - 1]]
        },
        getDaysTasks(date) {
            let result = this.tasks.find(x => x.date == date)
            return result ? result.tasks : []
        },
        getStatusColor(task) {
            switch (task.status) {
                case 'Complete':
                    return '#119c36'
                case 'Incomplete':
                    return 'red'
                case 'Pending':
                    return 'orange'
                case 'In Progress':
                    return 'lightblue'
                case 'Canceled':
                    return 'red'
                default:
                    return 'grey'
            }
        },
        async getChangeLogs(id) {
            let result = []
            await Api().get('/task/change/' + id).then(res => {
                result = res.data
            })
            return result
        },
        async getDocuments(id) {
            let result = []
            await Api().get('/upload/byTask/' + id).then(res => {
                result = res.data
            })
            return result
        },
        async getComment(id) {
            let result = []
            await Api().get('/taskComment/' + id).then(res => {
                result = res.data
            })
            return result
        },
        async getTaskForms(id) {
            let result = []
            await Api().get('/taskForm/' + id).then(res => {
                result = res.data
            })
            return result
        },

        isFuture(date) {
            let today = new Date()
            today.setHours(0, 0, 0, 0)
            return new Date(date) >= today
        },
        getTaskTemplates() {
            Api().get('/taskTemplate').then(res => {
                this.templates = res.data
            })
        },
        getForms() {
            Api().get('/forms').then(res => {
                this.forms = res.data
            })
        },
        async selectTask(task) {
            console.log(task)
            this.selectedTask = task
            if (task.parentTaskId) {
                this.selectedTask.parentTask = this.listTasks.find(x => x.id == task.parentTaskId)
            }

            this.selectedTask.subtasks = await this.fetchSubtasks(task.id)
            this.selectedTask.subtasks.forEach(x => {
                x.menu = false
                x.key = 0
            })
            this.selectedTask.taskCollaborators = await this.fetchTaskCollaborators(task.id)
            this.selectedTask.taskChanges = await this.getChangeLogs(task.id)
            this.selectedTask.documents = await this.getDocuments(task.id)
            this.selectedTask.taskComments = await this.getComment(task.id)
            this.modalKey++
            this.displayListTask = true
        },
        updateTask(task) {
            Api().put('/tasks/' + task.id, task)
        },
        updateStatus(task) {
            if (task.status == 'Complete') {
                task.status = 'Pending'
            } else {
                task.status = 'Complete'
            }
            Api().put('/tasks/' + task.id, {
                status: task.status
            })
        },
        async viewTask(task) {
            console.log(task)
            task.loading = true

            this.item = task
            this.item.subtasks = await this.fetchSubtasks(task.id)
            this.item.subtasks.forEach(x => {
                x.menu = false
                x.key = 0
            })
            this.item.taskCollaborators = await this.fetchTaskCollaborators(task.id)
            this.item.taskChanges = await this.getChangeLogs(task.id)
            this.item.documents = await this.getDocuments(task.id)
            this.item.taskComments = await this.getComment(task.id)
            this.item.taskForms = await this.getTaskForms(task.id)

            this.modalKey++
            this.taskModal = true
            task.loading = false

        }
    }
}
</script>

<style scoped>
.dotted {

    border-style: dotted;
}
</style>
